/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $FantaGroup = {
    properties: {
        name: {
            type: 'string',
            isRequired: true,
        },
        id: {
            type: 'number',
            isRequired: true,
        },
        league: {
            type: 'any-of',
            contains: [{
                type: 'LeagueListMinimum',
            }, {
                type: 'null',
            }],
            isRequired: true,
        },
        fantaTeams: {
            type: 'array',
            contains: {
                type: 'FantaGroupTeam',
            },
            isRequired: true,
        },
        creator: {
            type: 'UserSmall',
            isRequired: true,
        },
    },
} as const;
